import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// used for old enrollment flow
// interface CoveragesByCategoryPayload {
//   values: boolean[];
//   index: number;
// }

interface CoveragesByCategoryState {
  values: boolean[][];
  hasPreExistingBenefitElections: boolean[];
}

const initialState: CoveragesByCategoryState = {
  values: [],
  // each index corresponds to a page in the enrollment flow with benefits 0: questionnaire, 1: benefits
  // false means no pre-existing benefit elections and therefore do not show the banner, true means there are pre-existing benefit elections
  hasPreExistingBenefitElections: [false, false],
};

const coveragesByCategorySlice = createSlice({
  name: 'coveragesByCategory',
  initialState,
  reducers: {
    setHasPreExistingBenefitElections: (
      state,
      { payload }: PayloadAction<boolean[]>
    ) => {
      state.hasPreExistingBenefitElections = payload;
    },
  },
});

const { reducer, actions } = coveragesByCategorySlice;

export const { setHasPreExistingBenefitElections } = actions;

export const coveragesByCategory = reducer;
